export default {
    "REGISTER_TITLE_1": "Registre su cuenta fácilmente y comience a operar.",
    "REGISTER": "Registro",
    "ALREADY_HAVE_ACCOUNT": "¿Ya tienes una cuenta?",
    "ACCEPT_TERMS_MESSAGE": "Por favor acepte los Términos y Condiciones de Uso",
    "RECOVERY_PASSWORD_TITLE": "Escriba su contraseña registrada y le enviaremos un correo electrónico de recuperación de contraseña.",
    "EMAIL_NOT_EXISTS": "Cuenta de usuario no encontrada",
    "SIGN_IN_BUTTON": "Iniciar sesión",
    "EMAIL_PLACEHOLDER": "Dirección de correo electrónico",
    "ENTER_PASSWORD": "Introducir la contraseña",
    "KEEP_SIGN_COMPUTER": "Mantenerme conectado en esta computadora",
    "DON'T_HAVE_ACCOUNT": "no tengo una cuenta",
    "EMAIL_REQUIRED": "El campo de correo electrónico es obligatorio",
    "EMAIL_INVALID": "el correo electrónico es invalido",
    "ONLY_NUMERIC": "Solo valores numéricos permitidos",
    "INVALID_OTP": "OTP no válido",
    "FORGOT_PASSWORD": "Se te olvidó tu contraseña",
    "SIGN_IN": "Registrate gratis",
    "PASSWORD_PLACEHOLDER": "Clave",
    "PASSWORD_REQUIRED": "El campo de contraseña es obligatorio",
    "PASSWORD_INCORRECT": "Contraseña incorrecta",
    "CHECK_OPTION": "Por favor marque la opción",
    "HAVE_BACKUP": "tengo una copia de seguridad del codigo",
    "PASSWORD_MIN_MAX": "La contraseña debe contener al menos una mayúscula, al menos una minúscula, al menos un número, al menos un carácter especial y un mínimo de 6 y un máximo de 18",
    "CONFIRM_PASSWORD_MISMATCH": "Las contraseñas deben coincidir",
    "PASSWORD_CHANGE_SUCCESS": "Restablecimiento de contraseña con éxito",
    "PASSSWORD_RESET": "Restablecimiento de contraseña",
    "CURRENT_PASSWORD_REQUIRED": "El campo Contraseña actual es obligatorio",
    "CONFIRM_PASSWORD_REQUIRED": "El campo de confirmación de contraseña es obligatorio",
    "CONFIRM_PASSWORD": "Confirmar nueva contraseña",
    "UPDATE_PASSWORD": "Actualizar contraseña de inicio de sesión",
    "LOGIN": "Acceso",
    "ORDER_HISTORY": "Historial de pedidos",
    "DEFAULT_FIAT_CURRENCY": "Moneda fiduciaria predeterminada",
    "PAGE_AFTER_LOGIN": "Página predeterminada después de iniciar sesión",
    "DEFAULT_LANGUAGE": "Mi idioma predeterminado",
    "REF_CODE_OPTION": "Código de Referencia (Opcional)",
    "CURRENT_PASSWORD": "contraseña actual",
    "NEW_PASSWORD": "Nueva contraseña",
    "REFERRAL_CODE": "Código de referencia",
    "I_AGREE": "Acepto y estoy de acuerdo con el",
    "REFERRAL": "Remisión",
    "YOUR_REFERRAL_ID": "Su identificación de referencia",
    "INVITE_FRIENDS": "Invitar a amigos",
    "YOUR_TOTAL_REFERRAL": "Su ingreso total por referencias",
    "TERMS": "términos",
    "AND": "y",
    "PRIVACY": "Política de privacidad",
    "PASSWORD": "Clave",
    "OTP": "Fiscalía",
    "DEFINITION": "Definiciones",
    "OUR_TERMS": "Nuestros Términos",
    "TERMS_CONTENT_1": "Estos Términos de uso de Canopus Exchange se celebran entre usted (en lo sucesivo, \"usted\" o \"su\") y los operadores de Canopus Exchange (como se define a continuación). Al acceder, descargar, usar o hacer clic en \"Acepto\" para aceptar cualquier servicio de Canopus Exchange (como se define a continuación) proporcionado por Canopus Exchange (como se define a continuación), usted acepta que ha leído, comprendido y aceptado todos los términos y condiciones. estipulado en estos Términos de uso (en lo sucesivo, \"estos Términos\"), así como en nuestra Política de privacidad en https://www.Canopus Exchange.com/en/privacy. Además, al usar algunas funciones de los Servicios, puede estar sujeto a términos y condiciones adicionales específicos aplicables a esas funciones.",
    "TERMS_CONTENT_2": "Al acceder, usar o intentar usar los Servicios de Canopus Exchange en cualquier capacidad, usted reconoce que acepta y está de acuerdo en estar sujeto a estos Términos. Si no está de acuerdo, no acceda a Canopus Exchange ni utilice los servicios de Canopus Exchange.",
    "TERMS_CONTENT_3": "Canopus Exchange hace referencia a un ecosistema que comprende sitios web de Canopus Exchange (cuyos nombres de dominio incluyen, entre otros, https://www.Canopus Exchange.com), aplicaciones móviles, clientes, subprogramas y otras aplicaciones que se desarrollan para ofrecer Servicios de Canopus Exchange, e incluye plataformas, sitios web y clientes operados de forma independiente.",
    "TERMS_CONTENT_4": "Los Operadores de Canopus Exchange se refieren a todas las partes que ejecutan Canopus Exchange, incluidas, entre otras, las personas jurídicas, las organizaciones no incorporadas y los equipos que brindan los Servicios de Canopus Exchange y son responsables de dichos servicios. Por conveniencia, a menos que se indique lo contrario, las referencias a \"Canopus Exchange\" y \"nosotros\" en estos Términos significan específicamente Canopus Exchange.",
    "TERMS_CONTENT_5": "Los Servicios de Canopus Exchange se refieren a varios servicios que le brinda Canopus Exchange que se basan en Internet y/o tecnologías de cadena de bloques y se ofrecen a través de los sitios web, aplicaciones móviles, clientes y otras formas de Canopus Exchange (incluidos los nuevos habilitados por futuros desarrollos tecnológicos). Los servicios de Canopus Exchange incluyen, entre otros, componentes del ecosistema de Canopus Exchange como las plataformas de comercio de activos digitales, el sector financiero, Canopus Exchange Labs, Canopus Exchange Academy, Canopus Exchange Charity, Canopus Exchange Info, Canopus Exchange Launchpad, Canopus Exchange Research, Canopus Exchange Chain, Canopus Exchange X, Canopus Exchange Fiat Gateway, servicios existentes ofrecidos por Trust Wallet y nuevos servicios que proporcionará Canopus Exchange",
    "SEND_CODE": "Enviar código",
    "VERIFY_RECAPTCHA": "Verificar recaptcha",
    "MOBILE_NO": "Número de teléfono móvil",
    "ENTER_MOBILE_NO": "Introduce el número de móvil",
    "VERIFY_CODE": "Código de verificación",
    "REQUIRED": "Requerido",
    "PRICE_ONLY_NUMERIC": "Precio solo valor numérico",
    "FIRST_NAME_ALPHABET": "firstName Debe ser completado con Alfabetos",
    "LAST_NAME_ALPHABET": "lastName Debe ser llenado con Alfabetos",
    "BLOCKNO_NAME_ALPHABET": "blockNo Debe ser llenado con Alfabetos",
    "STATE_NAME_ALPHABET": "estado Debe ser llenado con Alfabetos",
    "CITY_NAME_ALPHABET": "ciudad Debe ser llenado con Alfabetos",
    "POSTAL_CODE_MUST_NUMBER": "postalCode Debe ser llenado con Números",
    "INVALID_EMAIL": "Email inválido",
    "ONLY_NUMERIC_POSITIVE": "Solo se permiten valores numéricos positivos",
    "QUANTITY_REQUIRED": "El campo de cantidad es obligatorio",
    "MAX_LIMIT_REQUIRED": "El campo de límite máximo es OBLIGATORIO",
    "MAX_LIMIT_4": "Límite máximo 4",
    "INVALID_CODE": "Codigo invalido",
    "TERMS_REQUIRED": "El campo de términos es obligatorio",
    "PERSONAL_DETAILS": "Detalles personales",
    "FULL_NAME": "Nombre completo",
    "RESIDENTIAL_ADDRESS": "Dirección residencial",
    "BUILDING_BLOCK": "Nombre del edificio/bloque",
    "ADDRESS": "Dirección",
    "STATE_PROVISION": "Provincia del estado",
    "CITY": "Ciudad",
    "POSTAL_CODE": "Código postal",
    "COUNTRY": "País",
    "EDIT_PROFILE": "Editar mi perfil",
    "Submit": "Entregar",
    "FIRST_NAME": "Primer nombre",
    "LAST_NAME": "Apellido",
    "NAME": "Nombre",
    "PROFILE_EDIT_SUCCESS": "¡Gracias, tu perfil ha sido actualizado!",
    "SOMETHING_WRONG": "Algo salió mal",
    "NO_DATA": "Datos no disponibles",
    "NO_ORDER": "no hay orden",
    "ORDER_CANCEL": "Su pedido cancelado con éxito",
    "ORDER_ALREADY_COMPLETED": "Tu pedido ya completado",
    "ORDER_ALREADY_CANCEL": "Tu pedido ya cancelado",
    "REGISTER_BANK_ACCOUNT": "Aquí puede registrar su cuenta bancaria dentro del sistema que le permitirá retirar fondos de Canopus Exchange",
    "ADD_BANK_ACCOUNT": "Agregar cuenta bancaria",
    "ADD_BANK": "Agregar banco",
    "READ": "Leer",
    "MY_BANK_ACCOUNT": "Mis cuentas bancarias",
    "DEFAULT": "Defecto",
    "BANK_ACCOUNT": "Cuenta bancaria",
    "CHANGE": "cambio",
    "BANK_NAME": "Nombre del banco",
    "ACCOUNT_NO": "Número de cuenta",
    "ACCOUNT_NUMBER": "Número de cuenta",
    "ACCOUNT_HOLDER_NAME": "nombre del titular de la cuenta",
    "IBAN_SWIF": "Código IBAN/Swift",
    "IBAN_CODE": "Código IFSC",
    "BANK": "Banco",
    "STATUS": "Estado",
    "CREATED_ON": "Crear en",
    "TWO_FA": "Autenticación de 2 factores",
    "EDIT": "Editar",
    "DELETE": "Borrar",
    "TWO_FA_MSG": "Debe habilitar 2FA para retirar fondos fiduciarios.",
    "BANK_EDIT_SUCCESS": "Datos bancarios actualizados con éxito",
    "BANK_ADD_SUCCESS": "Datos bancarios añadidos con éxito",
    "BANK_DELETE_SUCCESS": "Datos bancarios eliminados con éxito",
    "BANK_SET_PRIMARY_SUCCESS": "Datos bancarios predeterminados actualizados con éxito",
    "UPDATE": "Actualizar",
    "NOTES": "notas",
    "MIN_DEPOSIT_LIMIT": "Límite mínimo de depósito",
    "DEPOSIT_TIME": "El tiempo de depósito tomará de 4 a 24 horas debido a la red bancaria",
    "CHAT_ONLY_TRADE": "Chat solo información de detalles comerciales",
    "WITHDRAW_FIAT_DEPOSIT": "Retirar Depósito Fiat",
    "WITHDRAW_FIAT": "retirar fiat",
    "AVOID_WORNG_WORDS": "Evita palabras innecesarias",
    "TRANSFER_PAYMENT_BUTTON": "Haga clic en el botón Transferir pago para completar el pago al vendedor",
    "NEED_SUPPORT": "¿Necesita ayuda?",
    "CREAT_SUPPORT_TICKET": "Crear ticket de soporte",
    "SUPPORT_DETAILS": "Detalles de soporte",
    "2FA_VERIFID": "Verificación de código 2FA",
    "PASSWORD_TITLE": "Por medidas de seguridad, su contraseña debe contener:",
    "PASSWORD_DESCRIPTION1": "un mínimo de 6 caracteres de largo",
    "PASSWORD_DESCRIPTION2": "al menos una letra MAYÚSCULAS (A, B, X, Y...)",
    "PASSWORD_DESCRIPTION3": "al menos un dígito (0,1,2,9...)",
    "PASSWORD_DESCRIPTION4": "al menos un carácter especial (! @ # $ ^ *...)",
    "PASSWORD_DESCRIPTION5": "un máximo de 18 caracteres de largo",
    "PASSWORD_DESCRIPTION6": "al menos una letra MINUSCULAS (a,b,x,y...)",
    "TWO_FA_DESCRIPTION1": "Habilite la autenticación de dos factores como medida de seguridad adicional para proteger sus fondos y poder retirarlos. Utilice Google Authenticator, que puede",
    "TWO_FA_DESCRIPTION2": "Descargue el autenticador de Google haciendo clic en \"Descargar aquí\" y escanee el código QR. Recibirá un código de 6 dígitos, que debe ingresar en el cuadro 2FA.",
    "TWO_FA_DESCRIPTION3": "Abajo el código de 32 dígitos en un libro blanco para su seguridad si olvidó el código 2FA para retirar fondos",
    "DOWNLOAD_HERE": "Descarga aquí",
    "HOW_ENABLE": "Cómo habilitar",
    "ENABLE": "Habilitar 2FA",
    "DISABLE": "Deshabilitar 2FA",
    "ENTER_TWO_FA_CODE": "Ingrese el código 2FA de 6 dígitos",
    "TWO_FA_CODE": "Su código de seguridad de 32 dígitos",
    "SCAN_QR_CODE": "Escanear código QR",
    "DISABLED": "Desactivado",
    "ENABLED": "Activado",
    "TWO_FA_ENABLE_SUCCESS": "2FA habilitado con éxito",
    "TWO_FA_DISABLE_SUCCESS": "2FA deshabilitado con éxito",
    "EDIT_SETTING_SUCCESS": "Configuración actualizada con éxito",
    "IDENTITY_DOCUMENT": "Documento de identidad",
    "IDENTIFICATION_DOCUMENT": "Documento de identificación",
    "SELECTED_ID_NUMBER": "Ingrese el número de identificación del documento seleccionado",
    "FRONT_SIDE": "Lado delantero",
    "PICTURE_SCAN": "Imagen o escaneo que muestra las 4 esquinas",
    "MAX_1MB_IMG": "Máximo 1 MB en jpg/png",
    "BACK_SIDE": "Parte trasera",
    "SIDE": "Lado",
    "EXECTED_PRICE": "Precio Ejecutado",
    "EXECUTED": "Ejecutado",
    "ADA": "ADA",
    "SELFIE_SELECTED_ID": "Selfie con ID seleccionado",
    "IDENTITY_DOCUMENT_TITLE1": "Aquí puede verificar su identidad cargando uno de los documentos de identidad aprobados",
    "IDENTITY_DOCUMENT_DESCRIPTION1": "Todas las imágenes deben ser claramente visibles y el texto también claramente visible",
    "IDENTITY_DOCUMENT_DESCRIPTION2": "Si el texto no es legible, el rostro no está claro o la imagen borrosa debe descalificarse y NO se verificará el estado.",
    "IDENTITY_DOCUMENT_DESCRIPTION3": "La selfie o imagen con su identificación seleccionada debe mostrar una cara clara sosteniendo la identificación seleccionada. Por favor vea un ejemplo",
    "IDENTITY_DOCUMENT_DESCRIPTION4": "Si desea cambiar su documento de identidad póngase en contacto con nuestro",
    "IDENTITY_HINT1": "máx. Tamaño de 9 MB, jpg, png, pdf permitido",
    "IDENTITY_HINT2": "Máx. 9 MB en jpg/png/pdf",
    "HERE": "Aquí",
    "IDENTITY_DOCUMENT_VERIFIED": "Tu documento de identidad se ha subido correctamente",
    "SUPPORT_TEAM": "equipo de apoyo",
    "TICKET_FOR": "boleto para",
    "MSG_TO_SUPPORT_TEAM": "Mensaje al equipo de soporte",
    "ADDRESS_DOCUMENT_TITLE1": "Comprobante de domicilio residencial",
    "ADDRESS_DOCUMENT_TITLE2": "Documento de prueba de dirección",
    "ADDRESS_DOCUMENT_TITLE3": "Sube el documento",
    "ADDRESS_DOCUMENT_DESCRIPTION1": "El documento debe indicar claramente su nombre completo y dirección completa.",
    "ADDRESS_DOCUMENT_DESCRIPTION2": "- El documento NO debe tener más de 3 meses",
    "ADDRESS_DOCUMENT_DESCRIPTION3": "- Aprobado factura de servicios públicos factura de luz, factura de gas, teléfono fijo, factura de internet. Factura de teléfono móvil NO aceptada.",
    "ADDRESS_DOCUMENT_DESCRIPTION4": "Factura de servicios (Facturas de servicios aprobadas: factura de luz, factura de gas, teléfono fijo, factura de internet). Teléfono móvil no aceptado.",
    "ADDRESS_DOCUMENT_DESCRIPTION5": "Si desea cambiar su documento de dirección, comuníquese con nuestro",
    "ADDRESS_DOCUMENT_VERIFIED": "Su comprobante de domicilio ha sido enviado",
    "DRIVING_LICENSE": "Licencia de conducir",
    "UTILITY_BILL": "Factura de servicios públicos",
    "BANK_STATEMENT": "Extracto de cuenta",
    "CREDIT_CARD_STATEMENT": "extracto de tarjeta de crédito",
    "MUNICIPALITY_REGISTRATION": "Registro Municipal",
    "GOVERNMENT_ISSUED_ID": "Identificacion dada por el gobierno",
    "PASSPORT": "Pasaporte",
    "PANCARD": "Tarjeta de la cacerola",
    "GAS_BILL": "Factura del gas",
    "AADHAR_CARD": "Tarjeta Aadhar",
    "TOO_LARGE": "Demasiado grande",
    "INVALID_IMAGE": "Seleccione un formato válido",
    "IDENTITY_DOC_UPLOAD_SUCCESS": "Documento de identidad actualizado con éxito",
    "ADDRESS_DOC_UPLOAD_SUCCESS": "Documento residencial actualizado con éxito",
    "NOT_APPLY": "No aplicar",
    "VERIFIED": "Verificado",
    "NOT_VERIFIED": "No verificado",
    "REJECTED": "Rechazado",
    "BASIC": "Básico",
    "ADVANCED": "Avanzado",
    "PRO": "Pro",
    "BASIC_PENDING": "Pendiente básica",
    "BASIC_SUBMITTED": "Básico enviado",
    "SUBMITTED": "Presentado",
    "BASIC_VERIFIED": "Básico Verificado",
    "ADVANCED_Pending": "Pendiente avanzada",
    "PRO_PENDING": "pendiente profesional",
    "BASIC_USER": "Usuario Básico",
    "ADVANCED_USER": "Usuario avanzado",
    "PRO_USER": "Usuario profesional",
    "TYPE_BASIC_DESCRIPTION1": "Deposite criptomonedas hasta 10,00 € de valor",
    "TYPE_BASIC_DESCRIPTION2": "Opere en mercados criptográficos y fiduciarios",
    "TYPE_BASIC_DESCRIPTION3": "Retira cripto y fiat hasta 10,00 € de valor por un máximo de $2500",
    "ID_ADDRESS_PROOF": "Prueba de identificación y dirección",
    "DEFAULT_BANK_ACCOUNT_DETAIL": "Comprobante de cuenta bancaria (solo banco de retiro predeterminado)",
    "USER_ID": "ID de usuario",
    "MEMBER_SINCE": "Miembro desde",
    "VERIFICATION_TYPE": "Tipo de verificación",
    "EMAIL_PHONE": "Dirección de correo electrónico y teléfono",
    "VERIFY_NOW": "verifica ahora",
    "PENDING": "Pendiente",
    "PHONE": "Teléfono",
    "TRANS_WALLET_AMOUNT": "Importe de la billetera de transferencia",
    "WITHDRAW_ACCOUNT": "Retirar cuenta",
    "FIAT_WITHDRAW_DESCRIPTION1": "Retiro mínimo",
    "FIAT_WITHDRAW_DESCRIPTION2": "El retiro demorará entre 24 y 48 horas debido a la red bancaria / días festivos",
    "FINAL_WITHDRAW_AMOUNT": "Cantidad final de retiro",
    "WALLET_BALANCE": "Saldo de la cartera",
    "ENTER2FA_CODE": "Ingrese el código 2FA",
    "WALLET_TRANSFER": "Transferencia de billetera",
    "MIN_WITHDRAW_LIMIT": "Límite mínimo de retiro",
    "WITHDRAW_TIME_TAKE": "El tiempo de retiro tomará de 4 a 24 horas debido a la red bancaria",
    "WITHDRAW_AMOUNT": "Retirar cantidad",
    "FUND_TRANSFER": "Transferencia de fondos",
    "RECEIVER_EMAIL": "Correo electrónico del receptor",
    "WITHDRAW_ADDRESS": "Retirar dirección",
    "ALLOW_NUMERIC": "Solo numérico permitido",
    "QUANTITY_ONLY_NUMERIC": "Cantidad solo valor numérico",
    "SIDE_REQUIRED": "El campo lateral es OBLIGATORIO",
    "INVALID_SIDE": "Lado inválido",
    "MIN_LIMIT_REQUIRED": "El campo de límite mínimo es OBLIGATORIO",
    "SELECT_DATE": "Seleccione la fecha",
    "GREATER_THEN_CURRENT": "Seleccione una fecha mayor que la fecha actual",
    "LESS_LIMIT_PURCHASE": "Desde el precio límite debe ser menor que hasta el precio límite",
    "ACCEPT_TERMS": "Por favor acepte los términos y la política",
    "BALANCE": "Equilibrio",
    "DISTANCE": "Distancia",
    "INSUFFICIENT_BALANCE": "Saldo insuficiente",
    "KYC_SUBMIT_ALERT": "Envíe sus detalles de kyc",
    "INVALID_BANK_ACCOUNT": "Cuenta bancaria inválida",
    "VERIFICATION_LINK": "Enlace de verificación enviado a la dirección de correo electrónico",
    "INVALID_TOKEN": "simbolo no valido",
    "EXPIRY_TOKEN": "token de caducidad",
    "DEPOSIT_QR_CODE": "Para depositar usa este QR",
    "COIN_ADDRESS": "Su dirección de moneda",
    "COPY_ADDRESS": "Copiar dirección",
    "COIN_DEPOSIT_DESCRIPTION1": "Envíe solo LTC a esta dirección de depósito.",
    "COIN_DEPOSIT_DESCRIPTION2": "Depósito mínimo: 0.001 LTC",
    "COIN_DEPOSIT_DESCRIPTION3": "El envío de monedas o tokens que no sean LTC a esta dirección puede resultar en la pérdida de su depósito.",
    "WITHDRAW_TOO_LOW": "Importe final demasiado bajo",
    "FINAL_AMOUNT": "Cantidad final",
    "FIAT_DEPOSIT_DESCRIPTION1": "Depósito mínimo: 10€",
    "FIAT_DEPOSIT_DESCRIPTION2": "Debe subir comprobante de depósito en pdf/jpg e ingresar número de referencia/DNI",
    "ADMIN_ACCOUNT": "Cuenta de administrador",
    "DEPOSIT": "Depósito",
    "DEPOSIT_AMOUNT": "Cantidad del depósito",
    "UPLOAD_PROOF": "Cargar prueba",
    "STAKE_AMOUNT": "Monto de la apuesta",
    "T_HAVE_READ": "He leído el",
    "DEPOSIT_REQUEST_SUCCESS": "Solicitud de depósito enviada con éxito",
    "DEPOSIT_TOO_LOW": "Cantidad de depósito demasiado baja",
    "SELECT_CURRENCY": "Seleccione el tipo de moneda",
    "INVALID_WALLET_TYPE": "Tipo de billetera no válido",
    "WALLET_MIS_MATCH": "De billetera y a billetera deben ser diferentes",
    "TO_WALLET": "A la billetera",
    "FROM_WALLET": "De la billetera",
    "WALLET_TRANSFER_SUCCESS": "El proceso de conversión de billetera se completó con éxito",
    "OPEN_ORDER": "Ordenes abiertas",
    "CANCEL": "Cancelar",
    "ORDERS": "Pedidos",
    "SUBSCRIBE_ETH": "Suscríbete ETH",
    "LOT_AMOUNT": "cantidad de lote",
    "AVAILABLE_LOTS": "Disponibles 10 Lotes",
    "STAKE_LIMIT": "Límite de apuesta",
    "MINIMUM_LOT": "Mínimo 1 Lote",
    "LOT_SIZE": "Tamaño del lote",
    "INTEREST_PER_LOT": "interés por lote",
    "INDIVIDUAL_MAX": "máximo individual",
    "VALUE_DATE": "Fecha valor",
    "INTEREST_RATE": "Tasa de interés",
    "INT_DURATION_TIME": "Fecha de distribución de intereses",
    "REDEMPTION_DATE": "Fecha de redención",
    "EXPECT_INTEREST": "interés esperado",
    "HAVE_READ_AND_AGREE": "He leído y acepto las",
    "USER": "Usuario",
    "CURRENT_SUBSCRIPTION": "Suscripción actual",
    "TYPE": "Tipo",
    "RELEASE": "Liberación",
    "ENTER_CODE": "Introduzca el código",
    "PRICE": "Precio",
    "LATEST_PRICE": "Último precio",
    "FLEXIBLE": "Flexible",
    "LOCKED": "bloqueado",
    "SUBSCRIBE": "Suscribir",
    "STOP_LIMIT": "Límite de parada",
    "STOP_MARKET": "Stop-mercado",
    "TRAILING_STOP": "Parada final",
    "DEFAULT_THEME": "Tema predeterminado para operar",
    "LIGHT_THEME": "Tema de luz",
    "DARK_THEME": "Tema oscuro",
    "GENERAL_SETTINGS": "Configuración general",
    "GENERAL": "General",
    "HIGH_YIELD": "Alto rendimiento",
    "CRYPTOS": "criptos",
    "VACATION": "Vacación",
    "DISABLE_ALL_ADVERTISMENT_SELL": "Deshabilite toda su publicidad para vender temporalmente",
    "DISABLE_ALL_ADVERTISMENT_BUY": "Deshabilite toda su publicidad para comprar temporalmente",
    "YOUR_BALANCE": "Tu balance",
    "ESTIMATED_VALUE": "Valor estimado:",
    "BUSD": "BUSD",
    "BNB": "bnb",
    "TRX": "TRX",
    "XRP": "XRP",
    "OTHERS": "Otro",
    "TOTAL_BALANCE": "Saldo total de la cuenta",
    "TRANSFER_FUND": "Transferir fondos",
    "AMOUNT": "Monto",
    "WELCOME_TO": "Bienvenido a",
    "BANNER_DESCRIPTION_1": "Ponemos el poder en tus manos para",
    "BANNER_DESCRIPTION_2": "comprar, vender y comerciar moneda digital.",
    "GET_STARTED": "Empezar",
    "EXPLORE_MARKETS": "Explore nuestros mercados",
    "EXPLORE_MARKETS_DESCRIPTION_1": "El cambio de divisas líder en el mundo Canopus Exchange",
    "EXPLORE_MARKETS_DESCRIPTION_2": "Opere con Bitcoin, ETH y cientos de otras divisas de Canopus Exchange en minutos.",
    "BUY": "Comprar",
    "DASHBOARD": "Panel",
    "ADMIN_ANNOUNCEMENT": "Anuncio de administrador",
    "LAST_LOGIN": "Último acceso",
    "ADMIN": "Administración",
    "ACCOUNT": "Cuenta",
    "KYC_VERIFICATION": "Verificación KYC",
    "EMAIL": "Correo electrónico",
    "MOBILE_PHONE Phone": "Teléfono móvil",
    "2FA_TOOL_TIP1": "Para retirar fondos, habilite la autenticación de 2 factores",
    "ENABLE_NOW": "Habilitado ahora",
    "DISABLE_NOW": "Deshabilitar ahora",
    "LOGIN_PASSWORD": "Contraseña de inicio de sesión",
    "ALERT": "Alerta",
    "WHEN_ENABLE_DISABLE_2FA": "Cuando habilitar / deshabilitar 2FA",
    "WHEN_LOGIN_PWD_CHG": "Cuando cambie la contraseña de inicio de sesión",
    "MARKTING_PROMOTION_EMAIL": "Correo electrónico de marketing y promoción",
    "WALLET_BAL": "Saldo de la cartera",
    "AMOUNT_TO_STAKE": "Cantidad interesada a apostar",
    "SUBSCRIPTION_AMOUNT": "monto de la suscripción",
    "SUBSCRIPTION_DATE": "Fecha de suscripción",
    "WITHDRAW": "Retirar",
    "TRANSFER": "Transferir",
    "BTCUSDT": "BTC USDT",
    "FIAT_HISTORY": "Historia fiduciaria",
    "CRYPTO_HISTORY": "Historial de criptomonedas",
    "P2P_HISTORY": "Historial de pedidos P2P",
    "ADV_FIAT_DEPOSIT": "Depósito Fiat Avanzado hasta",
    "ADV_FIAT_WITHDRAW": "Retiro Fiat Avanzado hasta",
    "ALL_ADVANCE_FEATURE": "Todas las funciones avanzadas",
    "PLUS": "MÁS",
    "FIAT_DEPOSIT": "Depósito fiduciario",
    "DEPOSIT_BANK_INFO": "Información del banco de depósito",
    "SPOT_BALANCE": "Saldo al contado",
    "ACCOUNT_FEATURES": "Características completas de las cuentas",
    "UNLIMITED_FIAT_DEP_WITH": "Depósito y Retiro ILIMITADO de Fiat",
    "DERIVATIVE_BAL": "Saldo de derivados",
    "P2P_BAL": "Saldo P2P",
    "STATISTICS": "Estadísticas",
    "TOTAL_SPOT_TRADE": "Comercio al contado total completado",
    "TOTAL_DERIVATIVE_TRADE": "Total Derivados Colocados",
    "P2P_TRADE": "Comercio P2P",
    "OPEN": "Abierto",
    "SPOT_TRADE": "Comercio al contado",
    "DERIVATIVE_TRADE": "Comercio de derivados",
    "2FA_PASS_UPDATE": "Actualización de dos factores y contraseña",
    "ESCROW_STATUS": "Estado de depósito en garantía",
    "COMPLETED": "Terminado",
    "RECENT_TRANSACTION": "Transacciones Recientes",
    "LOGIN_HISTORY": "Historial de inicio de sesión",
    "NOTIFICATION_HISTORY": "Historial de notificaciones",
    "HISTORY": "Historia",
    "DATE": "Fecha",
    "SYMBOL": "Símbolo",
    "TRANSACTION_REF": "Ref. de transacción",
    "NO_RECORD": "Sin registro",
    "POST_AD": "Publicar anuncio",
    "MINUTES": "Minutos",
    "PLEASE_MAKE_PAYMENT": "Realice un pago dentro de los 30:00 minutos, de lo contrario, el pedido se cancelará automáticamente.",
    "TRADE_LIMIT": "Límite comercial",
    "TRANSFER_PAYMENT": "Pago transferido",
    "RELEASE_ASSET": "Liberar activo",
    "DISPUTE_TRADE": "Comercio de disputas",
    "RLY_TO_ADMIN": "Responder al administrador",
    "CLOSE_THE_TICKET": "Satisfecho, Cierra este ticket",
    "WANT_PAY": "Quiero pagar",
    "CANCEL_ORDER": "Cancelar orden",
    "WILL RECEIVE": "voy a recibir",
    "CALNEL_AD": "¿Está seguro de que desea cancelar el anuncio?",
    "IP_ADDRESS": "Dirección IP",
    "LOCATION": "Localización",
    "DEVICE": "Dispositivo",
    "FIAT_CRYPTO": "fiat/cripto",
    "TOTAL": "Total",
    "FIAT_WALLET": "Monedero Fiat",
    "CRYPTO_WALLET": "Monedero criptográfico",
    "SPOT": "PUNTO",
    "DERIVATIVE": "Derivado",
    "P2P": "P2P",
    "TRIGGER_CONDITION": "Condiciones de activación",
    "SELL_BITCOIN": "vender bitcoins",
    "BUY_BITCOIN": "comprar bitcoins",
    "BITCOIN": "Bitcoin",
    "ETHEREUM": "Etéreo",
    "TOTAL_STAKING": "Participación total",
    "RIPPLE": "Onda",
    "LITE_COION": "Litecoin",
    "TETHER_COIN": "TetherCoin",
    "FIND_COIN": "encontrar moneda",
    "WALLET": "Cartera",
    "FUND": "Fondo",
    "HOME": "Casa",
    "FEES": "Tarifa",
    "FAQ": "Preguntas más frecuentes",
    "TERMS_CONDITION": "Términos y condiciones",
    "TRANSFER_CONFIRM": "Transferir Confirmar",
    "STAKING_DELAILS": "Detalles de replanteo",
    "DAY_APY": "Día APY",
    "YESTERDAY_APY": "APY de Flexbile de ayer",
    "FLEXIBLE_INTERESTED": "Interés Flexible Por Mil",
    "PRIVACY_POLICY": "Política de privacidad",
    "REG_EMAIL_MOBILE": "Su dirección de correo electrónico registrada/número de teléfono móvil",
    "DOWNLOAD_APP": "Descarga la aplicación desde",
    "MARKETS": "Mercados",
    "SPOT_MARKET": "Mercado al contado",
    "DERIVATIVE_MARKET": "Mercado derivado",
    "POLICY": "política",
    "SUBMIT_POST": "Enviar mensaje",
    "POST_ID": "ID del mensaje",
    "POSTED_ON": "Publicado en",
    "MARKET": "Mercado",
    "SUPPORT": "Apoyo",
    "CONTACT_US": "Contáctenos",
    "CONTACT_PARAGRAPH_1": "Lorem Ipsum es simplemente un texto ficticio de la industria de la impresión y la composición tipográfica. Lorem Ipsum ha sido el texto ficticio estándar de la industria desde el siglo XVI.",
    "SUPPORT_TICKET": "Ticket de soporte",
    "NEWS_UPDATE_TITLE": "Recibe las últimas noticias y actualizaciones",
    "COPY_RIGHT": "© Copyright ©{{AÑO}} Todos los derechos reservados",
    "CONNECT_WITH_US": "Conéctate con nosotros",
    "CONTACT": "Contacto",
    "PROFILE": "Perfil",
    "PERSONAL": "Personal",
    "MY_ACCOUNT": "Mi cuenta",
    "LOGOUT": "Cerrar sesión",
    "KYC": "KYC",
    "CONTACT_DETAILS": "Detalles de contacto",
    "BANK_ACCOUNT_DETAIL": "Detalles de cuenta bancaria",
    "PROFILE_DESCRIPTION1": "Sus datos personales deben introducirse estrictamente <b>como se indica en sus documentos oficiales de identificación y comprobante de domicilio</b> su dirección debe ser la indicada en el comprobante de domicilio que se requiere para verificar la cuenta. Si tiene alguna duda, escríbanos a <a>{{SUPPORT_MAIL}}</a>",
    "PROFILE_IMAGE": "Imagen de perfil",
    "FILE_FORMAT1": "jpg/jpeg/png máximo {{TAMAÑO}}",
    "CHANGE_EMAIL": "Cambiar e-mail",
    "PHONE_NUMBER": "Número de teléfono",
    "SEND_OTP": "Enviar OTP",
    "RESEND_OTP": "Reenviar OTP",
    "ENTER_OTP": "Ingresar OTP",
    "SEC": "Segundo",
    "UPDATE_PHONE_NO": "Actualizar número de teléfono",
    "ADD_ANOTHER_ACCOUNT": "Agregar otra cuenta",
    "WHY_COIN": "¿Por qué moneda?",
    "PARAGRAPH_1": "Lorem Ipsum es simplemente un texto ficticio de la industria de la impresión y la composición tipográfica. Lorem Ipsum ha sido el texto ficticio estándar de la industria desde el siglo XVI.",
    "GOLD": "Oro",
    "PARAGRAPH_2": "Lorem Ipsum es simplemente un texto ficticio de la industria de la impresión y la composición tipográfica. Lorem Ipsum ha sido el texto ficticio estándar de la industria desde el año 1500. Lorem Ipsum es simplemente texto ficticio de la industria de la impresión y la composición tipográfica.",
    "START_TRADE": "Comience a operar al contado",
    "PARAGRAPH_3": "Lorem Ipsum es simplemente un texto ficticio de la industria de la impresión y la composición tipográfica. Lorem Ipsum ha sido el texto ficticio estándar de la industria desde el año 1500. Lorem Ipsum es simplemente texto ficticio de la industria de la impresión y la composición tipográfica.",
    "START_DERIVATIVE": "Comience a operar con derivados",
    "LIGHT": "Luz",
    "MODE": "Modo",
    "DARK": "Oscuro",
    "COIN": "Moneda",
    "FEATURE": "Características",
    "FREE": "Gratis",
    "INSTANT": "Instante",
    "TRADING": "comercio",
    "FIAT_EASILY": "Fiat fácilmente",
    "PROMPT": "Oportuno",
    "KYC_VERIFY": "Verificar KYC",
    "SECURE_PLATFORM": "Nuestra plataforma segura",
    "2FA_PROTECT": "2FA Protegido",
    "PARAGRAPH_4": "Lorem Ipsum es simplemente un texto ficticio de la industria de la impresión y la composición tipográfica.",
    "PARAGRAPH_5": "Lorem Ipsum es simplemente un texto ficticio de la industria de la impresión y la composición tipográfica.",
    "PARAGRAPH_6": "Lorem Ipsum es simplemente un texto ficticio de la industria de la impresión y la composición tipográfica.",
    "256-BIT": "Cifrado de 256 bits",
    "SECURE_WALLET": "Cartera asegurada",
    "JOIN_REFERRAL_HEADING": "Únase a nuestro programa de referencia",
    "EARN_MONEY": "Empieza a ganar dinero invitando a amigos",
    "JOIN_REFERRAL": "Únase a nuestra referencia",
    "GET_STARTED_HEADING": "Comience en unos minutos",
    "SIGN_UP": "Regístrate",
    "ACCOUNT_ACCESS": "Acceso instantáneo a la cuenta en 2 minutos",
    "VERIFY": "Verificar",
    "PASSWORD_ADDRESS": "con pasaporte y comprobante de dirección",
    "TRADE": "Comercio",
    "PAIR_PROFIT": "con múltiples pares y beneficios contables",
    "TRADE_WITH": "Comercio con la aplicación móvil",
    "FOOTER_P": "Compatible con múltiples dispositivos, comience a operar con seguridad y comodidad.",
    "P2P_TRADING": "Comercio P2P",
    "PARAGRAPH_7": "Lorem Ipsum es simplemente un texto ficticio de la industria de la impresión y la composición tipográfica. Lorem Ipsum ha sido el estándar de la industria.",
    "I_WANT_TO": "Yo quiero",
    "ACCOUNT_FROZEN": "Los clics maliciosos conducirán a la congelación de la cuenta",
    "SELL": "Vender",
    "PAY_WITH_TIME_LIMIT": "Pague dentro del límite de tiempo, de lo contrario, el pedido se cancelará automáticamente 1",
    "PAY_TRADE_TERMS": "Solo pague según los términos comerciales",
    "CONFIRM_PAYMENT": "Confirmar pago",
    "PAYMENT_MADE_SELLER": "Por favor, confirme que el pago se ha realizado al vendedor.",
    "SELECT_CRYPTO": "Seleccione Cripto",
    "PAYMENT_TYPE": "Tipo de pago",
    "START_p2p": "Iniciar P2p",
    "ID_DOCUMENT": "Documento de identidad:",
    "ADDRESS_PROOF": "Verificación de domicilio:",
    "2FA_HEADING": "Autenticación en 2 pasos",
    "DIGITAL_CODE": "Ingrese el código 2FA de seis dígitos",
    "PASTE_CODE": "Pegar código",
    "CONFIRM": "Confirmar",
    "SECURITY_SETTINGS": "Configuraciones de seguridad",
    "POST_NEW_AD": "Publicar nuevo anuncio",
    "P2P_STATISTICS": "Estadísticas P2P",
    "TOTAL_TRADES": "Operaciones totales",
    "FIRST_TRADE": "primer comercio",
    "TRADES": "vientos alisios",
    "COMPLETION": "terminación",
    "AVL": "Promedio",
    "CREATED_TIME": "Tiempo creado",
    "ORDER_ID": "Solicitar ID",
    "ATTACHMENT": "Adjunto archivo",
    "MORE_ABOUT_SUPPORT": "Más sobre soporte",
    "LOGIN_ISSUE": "Problema de inicio de sesión",
    "DEPOSIT_ISSUE": "Emisión de depósito",
    "WITHDRAW_ISSUE": "Retirar problema",
    "ADMIN_RLY": "Respuesta del administrador en",
    "CONFIRM_MY_POST": "Confirmar mi publicación",
    "FILTER_BY": "Filtrado por",
    "REPLAY": "Respuesta",
    "BACK": "Atrás",
    "YOUR_API_KEY": "Tus claves API",
    "ID": "Identificación",
    "CREATED": "Creado",
    "PERMISSION": "permisos",
    "ACTION": "Acción",
    "STAKE_NOW": "Apuesta ahora",
    "LOADING": "Cargando...",
    "INVALID_URL": "URL invalida",
    "TRANSFER_BITCOIN": "Transferir bitcoins",
    "TICKET_ID": "Identificación de entradas",
    "POST_HISTORY": "Historial de publicaciones",
    "REF_KEY_LATER": "Nombre opcional para esta clave. Esto le ayudará a hacer referencia a esta clave más adelante.",
    "IP_RESTRICTION": "Restricciones de acceso IP:",
    "SECURITY_REASONS": "Por razones de seguridad, no revele su(s) clave(s) a terceros que no sean de confianza. Recomendamos que los usuarios agreguen sus direcciones IP a cada una de las claves API. Se puede agregar un máximo de cuatro (4) direcciones IP a cada clave. Para agregar varias direcciones IP, introdúzcalas por separado con comas entre ellas. por ejemplo, 192.168.1.1, 192.168.1.2, 192.168.1.3",
    "CREATE_API_KEY": "Crear clave API",
    "WRITE_SECRET_KEY": "Por favor, escriba la clave secreta.",
    "SOMEWHERE_SAFE": "¡Escríbelo en algún lugar seguro! La clave secreta ya no estará disponible una vez que abandone esta página.",
    "SECRET": "Secreto",
    "USD": "Dólar estadounidense",
    "EURO": "Euro",
    "CRYPTO": "Cripto",
    "LAST_PRICE": "Ultimo precio",
    "FIAT": "Fíat",
    "YOUR_FULL_NAME": "Tu nombre completo",
    "SUBJECT": "Asunto",
    "MESSAGE": "Mensaje",
    "CONTRACTS": "Contratos",
    "FILLED_TOTAL": "Lleno/Total",
    "FILLED_PRICE": "Precio completo",
    "FILLED": "Completado",
    "TRADE_HISTORY": "Historia comercial",
    "ORDER_PRICE": "Precio del pedido",
    "TRADE_TYPE": "Tipo de comercio",
    "ORDER_TYPE": "Tipo de orden",
    "ORDER_NO": "N º de pedido.",
    "Download_PDF": "Descargar PDF",
    "CANCEL_POST": "Cancelar mi publicación",
    "ORDER_TIME": "Tiempo de la orden",
    "SIZE": "Tamaño",
    "TAKER_PRICE": "Beneficio del tomador",
    "STOP_LOSS": "Detener la pérdida de",
    "GTC": "GTC",
    "IOC": "COI",
    "FOK": "FOK",
    "LONG": "Largo",
    "SHORT": "Corto",
    "VALUE": "Valor",
    "COST": "Costo",
    "TP_SL": "TP/SL",
    "24H_CHANGE": "Cambio 24h",
    "24_HIGH": "24h alta",
    "24_LOW": "24h Baja",
    "24H_VOLUME": "Volumen 24h",
    "QTY": "Cantidad",
    "ORDER_BOOK": "Libro de pedidos",
    "PLACE_ORDER": "Realizar pedido",
    "LIMIT": "Límite",
    "PERPETUAL": "Perpetuo",
    "BTC_PAIRS": "Pares BTC",
    "ETH_PAIRS": "Pares ETH",
    "PAIRS": "Pares",
    "MARKET_CLOSE": "Cierre del mercado",
    "CLOSE_QTY": "Cerrar Cantidad USD",
    "5CONTRACT_CLOSE": "5 Contrato(s) se cerrarán al último precio negociado y su ganancia esperada será",
    "INCLUSIVE": "incluidos los costos de colsing estimados",
    "FEE_CONTENT": "Lorem Ipsum es simplemente un texto ficticio de la industria de la impresión y la composición tipográfica. Lorem Ipsum ha sido el texto ficticio estándar de la industria desde el siglo XVI.",
    "ENTYRY_PRICE": "Precio de entrada",
    "IDENTITY_VERIFICATION": "Verificación de identidad",
    "LIQ_PRICE": "Liq. Precio",
    "POSITION_MARGIN": "Margen de posición",
    "UNREALIZED": "PyG no realizado (%)",
    "DAILY_REALIZED": "Pérdidas y ganancias diarias realizadas",
    "CLOSED_BY": "Cerca a",
    "RECENT_TRADE": "Operaciones recientes",
    "TIME": "Tiempo",
    "STOP_PRICE": "Precio de parada",
    "LIMIT_PRICE": "Precio límite",
    "POSITION": "Posición",
    "EDIT_MY_POST": "Editar mi publicación",
    "CRYPTO_CURRENCY": "criptomoneda",
    "SELECT_COIN": "Seleccionar moneda",
    "Quantity": "Cantidad",
    "PRICE_CURRENCY": "Precio Moneda",
    "CURRENCY_MARKET_PRICE": "Precio de mercado actual",
    "PRICE_LIMIT_MARKET": "Límite de precio desde",
    "SHOW_MY_POST": "Mostrar mi publicación hasta",
    "PERFERRED_PAYMENTS": "Pagos Preferidos",
    "PAYMENT_TO_MADE": "Pago a realizar",
    "PRICE_LIMIT_FROM": "Límite de precio desde",
    "PRICE_LIMIT_TO": "Límite de precio hasta",
    "SELECT_PAYMENT": "Seleccione Pago",
    "DURATION_DAYS": "Duración (Días)",
    "I_AGREE_ESCROW": "Acepto depositar en custodia mis fondos criptográficos y acepto el",
    "DURATION": "Duración",
    "ALL": "Todos",
    "ETH": "ETH",
    "APY": "APY",
    "XRB": "XRB",
    "SPOT_WALLET": "Monedero al contado",
    "DERIVATIVE_WALLET": "Cartera de derivados",
    "P2P_WALLET": "Monedero P2P",
    "FORM": "Desde",
    "QUANTITY": "cantidad",
    "FLEX_STAKING": "Replanteo flexible",
    "LOCKED_STAKING": "Replanteo bloqueado",
    "MIN_SUBSCRIPTION": "Suscripción mínima",
    "SUBSCRIPTION": "suscripción",
    "MAX_SUBSCRIPTION": "Suscripción máxima",
    "STAKING_HISTORY": "Historial de apuestas",
    "REDEMPTION_PERIOD": "Período de redención",
    "REDEMPTION": "Redención",
    "READ_AND_AGREE": "He leído y acepto las",
    "STAKING_TERMS": "Términos de apuesta",
    "INTEREST": "Interés",
    "STAKING": "replanteo",
    "BTC/USD": "USD/BTC",
    "DIGITAL_ASSETS": "Activos digitales líderes",
    "ONE_PLATFORM": "bajo una plataforma",
    "MATKET_PRICE": "Precio de los mercados",
    "SPOT_ORDERS": "Órdenes al contado",
    "DERIVATIVE_ORDERS": "Órdenes Derivadas",
    "P2P_ORDERS": "Pedidos P2P",
    "STAKING_ORDERS": "Órdenes de replanteo",
    "MANA": "MANÁ",
    "BTC": "BTC",
    "DAYS": "Dias",
    "TOTAL_VOLUME": "Volumen total",
    "TOTAL_TRADE_COMPLETE": "Comercio total completo",
    "ENTER_AMOUNT": "Ingrese la cantidad",
    "VIEW_CHAT": "Ver/Chatear",
    "PAY_BY": "Pagado por",
    "ALL_PAYMENT": "todo el pago",
    "AVAILABLE": "Disponible",
    "SELLER_PAYMENT_TYPE": "Tipo de pago del vendedor",
    "PAYMENT_TIME_LIMIT": "Límite de tiempo de pago",
    "RECENT_POST": "Publicación reciente",
    "TO": "Para",
    "DEPOSIT_CURRENCY": "Moneda de depósito",
    "YOUR": "Su",
    "WALLET_ADDRESS": "Dirección de la billetera"
}